import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  paymentGateway: [],
  GatewayManagement: [],
  userPurchase: [],
}

export const GetPaymentList: any = createAsyncThunk(
  '/GetPaymentList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/getPaymentGateway`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const updateAutotopup: any = createAsyncThunk(
  '/updateAutotopup',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}user/update-auto-popup-setting`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => {
        toast.success('updated successfully!')
      })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetPaymentList())
    thunkApi.dispatch(fetchAsyncUserDetails())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetPurchaseHistory: any = createAsyncThunk(
  '/GetPurchaseHistory',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/get-user-orders-admin/${data.id}`, {
      params: data.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)
export const GetPurchaseHistoryStaff: any = createAsyncThunk(
  '/GetPurchaseHistoryStaff',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}creditTransactions/${data.id}`, {
      params: data.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)
export const CreatePaymentMethod: any = createAsyncThunk(
  '/CreatePaymentMethod',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/createPaymentGateway`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetPaymentList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const UpdatePaymentDetails: any = createAsyncThunk(
  '/UpdatePaymentDetails',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/updatePaymentGateway/${data?.id}`, data?.paymentMethod, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success('updated successfully!'))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetPaymentList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const DeletePaymentMethod: any = createAsyncThunk(
  '/DeletePaymentMethod',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/deletePaymentGateway/${data?.id}`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success('Deleted successfully!'))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetPaymentList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

///////////////////////////////////Gateway Management////////////////////////////////////////////

export const GetGatewayManagementList: any = createAsyncThunk(
  '/GetGatewayManagementList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/getGatewayProvider`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const UpdateGatewaymanagement: any = createAsyncThunk(
  ' UpdateGatewaymanagement',
  async (data: any, thunkApi) => {
    const response: any = await axios.put(
      `${API_URL}admin/updateGatewayProvide/${data?.id}`,
      data?.gateway,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    {
      response?.data?.status == true && toast.success(response?.data?.message)
    }
    thunkApi.dispatch(GetGatewayManagementList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const CreateInvoiceForClient: any = createAsyncThunk(
  ' CreateInvoiceForClient',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}user/sendinvoicetocustomer`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const Gateway = createSlice({
  name: 'Gateway',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin------------Payment Gateway///////////////////////////////////////////////////////////////////
    [GetPaymentList.fulfilled]: (state, {payload}) => {
      return {...state, paymentGateway: payload.data}
    },

    [GetGatewayManagementList.fulfilled]: (state, {payload}) => {
      return {...state, GatewayManagement: payload.data}
    },

    [GetPurchaseHistory.fulfilled]: (state, {payload}) => {
      return {...state, userPurchase: payload.data}
    },
    [GetPurchaseHistoryStaff.fulfilled]: (state, {payload}) => {
      return {...state, staffPurchase: payload.data}
    },
  },
})

export default Gateway.reducer
